import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PreviewSurveyPage from 'components/pages/PreviewSurvey';

import pageTitles from 'utils/pageTitles';
import getRouteState from 'utils/getRouteState';
import { historyShape } from 'utils/shapes/router.shapes';
import { setTitle, setActiveMenuItem } from 'containers/store';

import { loadPageData } from './store';

class PreviewSurvey extends React.Component {
  static propTypes = {
    history: historyShape.isRequired,
    intl: intlShape.isRequired,
    isLoadedPage: PropTypes.bool.isRequired,
    loadPageData: PropTypes.func.isRequired,
    setActiveMenuItem: PropTypes.func.isRequired,
    setTitle: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.setTitle(this.props.intl.formatMessage(pageTitles.previewSurvey));
    this.props.setActiveMenuItem('surveys');
    const routeState = getRouteState(this.props.history);
    this.props.loadPageData(routeState);
  }

  render() {
    return this.props.isLoadedPage ? (
      <PreviewSurveyPage
        {...this.props}
      />
    ) : null;
  }
}

const mapDispatchToProps = {
  setTitle,
  setActiveMenuItem,
  loadPageData,
};

const mapStateToProps = (state) => ({
  ...state.PreviewSurvey,
});


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(withRouter(PreviewSurvey)));
